import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksManufacturedMaterials(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		dtConfig[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].getDoneWorksManufacturedMaterials,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksManufacturedMaterialPreview(companyId, doneWorkId, manufacturedMaterialId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		dtConfig[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].getDoneWorksManufacturedMaterialPreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				manufacturedMaterialId,
			},
		},
	)
}
function getDoneWorksManufacturedMaterialPopup(companyId, doneWorkId, manufacturedMaterialId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		dtConfig[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].getDoneWorksManufacturedMaterialPopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				manufacturedMaterialId,
			},
		},
	)
}

function createDoneWorksManufacturedMaterial(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,dtConfig[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].createDoneWorksManufacturedMaterial, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksManufacturedMaterial(companyId, doneWorkId, manufacturedMaterialId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,dtConfig[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].getDoneWorksManufacturedMaterial, {
		urlParams: {
			companyId,
			doneWorkId,
			manufacturedMaterialId,
		},
	})
}

function patchDoneWorksManufacturedMaterial(companyId, doneWorkId, manufacturedMaterialId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,dtConfig[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].patchDoneWorksManufacturedMaterial, {
		urlParams: {
			companyId,
			doneWorkId,
			manufacturedMaterialId,
		},
		...data,
	})
}

function putDoneWorksManufacturedMaterial(companyId, doneWorkId, manufacturedMaterialId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,dtConfig[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].putDoneWorksManufacturedMaterial, {
		urlParams: {
			companyId,
			doneWorkId,
			manufacturedMaterialId,
		},
		...data,
	})
}

function deleteDoneWorksManufacturedMaterial(companyId, doneWorkId, manufacturedMaterialId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,dtConfig[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].deleteDoneWorksManufacturedMaterial, {
		urlParams: {
			companyId,
			doneWorkId,
			manufacturedMaterialId,
		},
	})
}

export default {
	getDoneWorksManufacturedMaterials,
	getDoneWorksManufacturedMaterialPopup,
	getDoneWorksManufacturedMaterialPreview,
	getDoneWorksManufacturedMaterial,
	patchDoneWorksManufacturedMaterial,
	putDoneWorksManufacturedMaterial,
	createDoneWorksManufacturedMaterial,
	deleteDoneWorksManufacturedMaterial,
}
